const AllBookPage =

    [

        {
            "id": "mnemonicmath1",
            "type": "mnemonic",
            "subject": "math",
            "topic": "CM01",
            "pagename": "mnemonicmath1",
        },
        {
            "id": "mnemonicmath2",
            "type": "mnemonic",
            "subject": "math",
            "topic": "CM01",
            "pagename": "mnemonicmath2",
        },
        {
            "id": "mnemonicmath3",
            "type": "mnemonic",
            "subject": "math",
            "topic": "CM01",
            "pagename": "mnemonicmath3",
        },
        {
            "id": "mnemonicmath4",
            "type": "mnemonic",
            "subject": "math",
            "topic": "CM01",
            "pagename": "mnemonicmath4",
        },
        {
            "id": "mnemonicmath5",
            "type": "mnemonic",
            "subject": "math",
            "topic": "CM01",
            "pagename": "mnemonicmath5",
        },
        {
            "id": "mnemonicmath6",
            "type": "mnemonic",
            "subject": "math",
            "topic": "CM01",
            "pagename": "mnemonicmath6",
        },
        {
            "id": "mnemonicmath7",
            "type": "mnemonic",
            "subject": "math",
            "topic": "CM01",
            "pagename": "mnemonicmath7",
        },
        {
            "id": "mnemonicmath8",
            "type": "mnemonic",
            "subject": "math",
            "topic": "CM01",
            "pagename": "mnemonicmath8",
        },
        {
            "id": "mnemonicmath9",
            "type": "mnemonic",
            "subject": "math",
            "topic": "CM01",
            "pagename": "mnemonicmath9",
        },


        {
            "id": "mnemonicphy1",
            "type": "mnemonic",
            "subject": "physics",
            "topic": "CP01",
            "pagename": "mnemonicphy1",
        },
        {
            "id": "mnemonicphy2",
            "type": "mnemonic",
            "subject": "physics",
            "topic": "CP01",
            "pagename": "mnemonicphy2",
        },
        {
            "id": "mnemonicphy3",
            "type": "mnemonic",
            "subject": "physics",
            "topic": "CP01",
            "pagename": "mnemonicphy3",
        },
        {
            "id": "mnemonicphy4",
            "type": "mnemonic",
            "subject": "physics",
            "topic": "CP01",
            "pagename": "mnemonicphy4",
        },


        {
            "id": "mnemonicche1",
            "type": "mnemonic",
            "subject": "chemistry",
            "topic": "CC01",
            "pagename": "mnemonicche1",
        },
        {
            "id": "mnemonicche2",
            "type": "mnemonic",
            "subject": "chemistry",
            "topic": "CC01",
            "pagename": "mnemonicche2",
        },
        {
            "id": "mnemonicche3",
            "type": "mnemonic",
            "subject": "chemistry",
            "topic": "CC01",
            "pagename": "mnemonicche3",
        },
        {
            "id": "mnemonicche4",
            "type": "mnemonic",
            "subject": "chemistry",
            "topic": "CC01",
            "pagename": "mnemonicche4",
        },
        {
            "id": "mnemonicche5",
            "type": "mnemonic",
            "subject": "chemistry",
            "topic": "CC01",
            "pagename": "mnemonicche5",
        },
        {
            "id": "mnemonicche6",
            "type": "mnemonic",
            "subject": "chemistry",
            "topic": "CC01",
            "pagename": "mnemonicche6",
        },
        {
            "id": "mnemonicche7",
            "type": "mnemonic",
            "subject": "chemistry",
            "topic": "CC01",
            "pagename": "mnemonicche7",
        },
        {
            "id": "mnemonicche8",
            "type": "mnemonic",
            "subject": "chemistry",
            "topic": "CC01",
            "pagename": "mnemonicche8",
        },



    ]

export default AllBookPage;